module.exports = __webpack_public_path__ + "static/media/next-arrow.4593acc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next-arrow.png
// module id = 2070
// module chunks = 0